import { Stack, Button, Typography } from '@mui/material';
import { IconSvg } from '@/components/Icon';
type Props = {
  iNoticeHandler: () => void;
};
const DoneSyncSejam = (props: Props) => {
  return <Stack alignItems='center' sx={{
    px: {
      xs: 'var(--spacing_m)',
      md: 'var(--spacing_xl)'
    }
  }} data-sentry-element="Stack" data-sentry-component="DoneSyncSejam" data-sentry-source-file="DoneSyncSejam.tsx">
      <Stack alignItems='center' sx={{
      width: '100%',
      fontSize: {
        xs: 56,
        md: 72
      },
      py: {
        xs: 'var(--spacing_m)',
        md: 'var(--spacing_l)'
      }
    }} data-sentry-element="Stack" data-sentry-source-file="DoneSyncSejam.tsx">
        <IconSvg component='AuthorizeDone' data-sentry-element="IconSvg" data-sentry-source-file="DoneSyncSejam.tsx" />
      </Stack>
      <Typography component='p' sx={{
      typography: {
        xs: 'bodyRegular__Wallfund',
        md: 'bodyLargeRegular__Wallfund'
      },
      py: 'var(--spacing_s)'
    }} data-sentry-element="Typography" data-sentry-source-file="DoneSyncSejam.tsx">
        همگام‌سازی و احراز هویت با موفقیت انجام شد.
      </Typography>
      <Stack sx={{
      width: '100%',
      pt: 'var(--spacing_m)',
      pb: {
        xs: 'var(--spacing_m)',
        md: 'var(--spacing_xl)'
      }
    }} data-sentry-element="Stack" data-sentry-source-file="DoneSyncSejam.tsx">
        <Button onClick={props.iNoticeHandler} fullWidth variant='ghost' size='large' data-sentry-element="Button" data-sentry-source-file="DoneSyncSejam.tsx">
          متوجه شدم
        </Button>
      </Stack>
    </Stack>;
};
export default DoneSyncSejam;